export const WA_PEDIDOS = 'https://wa.me/525556030293';
export const WA_CONTACTO = 'https://wa.me/525575110551';
